import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Droplet, Package, Factory, Wrench } from 'lucide-react';
import { Button } from '../ui/button';
import { Card, CardContent } from '../ui/card';
import { manufacturingProcess } from '../../mock/mockData';

const ManufacturingSection = () => {
  return (
    <>
      {/* Manufacturing Process Preview */}
      <section className="py-20 bg-gradient-to-br from-alden-green-dark to-alden-green text-white">
        <div className="container mx-auto px-4">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold mb-4">
              Our Manufacturing Excellence
            </h2>
            <p className="text-lg text-white/90 max-w-3xl mx-auto">
              State-of-the-art 15,000 sq. ft. manufacturing facility with advanced CNC machining, laser cutting, and quality control.
            </p>
          </div>

          <div className="grid md:grid-cols-4 gap-6 mb-12">
            {manufacturingProcess.slice(0, 4).map((process, idx) => (
              <Card key={process.id} className="bg-white/10 backdrop-blur-sm border-2 border-white/20 hover:bg-white/20 transition-all">
                <CardContent className="p-6 text-center">
                  <div className="w-12 h-12 bg-white/20 rounded-full flex items-center justify-center mx-auto mb-4 text-2xl font-bold">
                    {idx + 1}
                  </div>
                  <h3 className="font-bold text-lg mb-2">{process.title}</h3>
                  <p className="text-sm text-white/80">{process.description}</p>
                </CardContent>
              </Card>
            ))}
          </div>

          <div className="text-center">
            <Link to="/manufacturing-facility">
              <Button className="bg-white text-alden-green hover:bg-gray-100 py-6 px-10 text-lg font-semibold">
                View Complete Manufacturing Process
                <ArrowRight className="ml-2" />
              </Button>
            </Link>
          </div>
        </div>
      </section>

      {/* Industries We Serve */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-4">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
              Industries We <span className="text-alden-green">Serve</span>
            </h2>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto">
              Providing complete turnkey solutions for various beverage and water treatment industries.
            </p>
          </div>

          <div className="grid md:grid-cols-4 gap-6 max-w-5xl mx-auto">
            {[
              { id: 'ind-pdw', title: 'Packaged Drinking Water', icon: Droplet },
              { id: 'ind-mw', title: 'Mineral Water', icon: Package },
              { id: 'ind-juice', title: 'Juice Processing', icon: Factory },
              { id: 'ind-csd', title: 'Carbonated Soft Drinks', icon: Package },
              { id: 'ind-bulk', title: 'Bulk Water Supply', icon: Droplet },
              { id: 'ind-comm', title: 'Commercial Bottling', icon: Factory },
              { id: 'ind-contract', title: 'Contract Manufacturing', icon: Wrench },
              { id: 'ind-fb', title: 'Food & Beverage', icon: Package }
            ].map((industry) => (
              <Card key={industry.id} className="border-2 border-alden-green/20 hover:border-alden-green transition-all text-center">
                <CardContent className="p-6">
                  <industry.icon className="w-12 h-12 text-alden-green mx-auto mb-3" />
                  <h3 className="font-bold text-gray-900">{industry.title}</h3>
                </CardContent>
              </Card>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default ManufacturingSection;
